import React from "react";
import { Separator } from "react-resizable-panels";

const baseHandleStyle = {
  backgroundColor: "transparent",
  border: 0,
  boxShadow: "none",
  boxSizing: "border-box",
  position: "relative",
  zIndex: 5,
};

const baseGripStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.28)",
  borderRadius: 999,
  boxShadow:
    "0 0 0 1px rgba(255, 255, 255, 0.18), 0 2px 6px rgba(0, 0, 0, 0.45)",
};

export const ResizablePanelHandle = ({
  direction = "horizontal",
  className = "",
  style,
  ...rest
}) => {
  const isHorizontal = direction === "horizontal";
  const gapSize = 4;
  const handleStyle = {
    ...baseHandleStyle,
    ...(isHorizontal
      ? {
          height: "8px",
          minHeight: "8px",
          cursor: "row-resize",
          margin: `${gapSize}px 0`,
        }
      : {
          width: "8px",
          minWidth: "8px",
          cursor: "col-resize",
          margin: `0 ${gapSize}px`,
        }),
    ...style,
  };
  const gripStyle = isHorizontal
    ? { width: "32px", height: "2px" }
    : { width: "2px", height: "32px" };

  return (
    <Separator
      {...rest}
      className={`panel-resize-handle d-flex align-items-center justify-content-center ${className}`}
      style={handleStyle}
    >
      <div
        className="panel-resize-handle__grip"
        style={{ ...baseGripStyle, ...gripStyle }}
      />
    </Separator>
  );
};
